import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-opencv',
  templateUrl: './opencv.component.html',
  styleUrls: ['../../../app.component.scss', './opencv.component.scss']
})
export class OpencvComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
